var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"status-box"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.cover_src,"alt":""}}),_c('p',{},[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }